import React from 'react'

export const Contact = () => (
    <div>
        <h1>Contact</h1>
    </div>
)